/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as WantToDrinkRouteImport } from './../../pages/want-to-drink'
import { Route as TeaDiaryRouteImport } from './../../pages/tea-diary'
import { Route as ReviewsRouteImport } from './../../pages/reviews'
import { Route as ProfileRouteImport } from './../../pages/profile'
import { Route as PrivacyRouteImport } from './../../pages/privacy'
import { Route as PaymentResultRouteImport } from './../../pages/payment-result'
import { Route as OrdersRouteImport } from './../../pages/orders'
import { Route as OrderSuccessRouteImport } from './../../pages/order-success'
import { Route as OfferRouteImport } from './../../pages/offer'
import { Route as NotFoundRouteImport } from './../../pages/not-found'
import { Route as MyGiftCardsRouteImport } from './../../pages/my-gift-cards'
import { Route as GiftCardsRouteImport } from './../../pages/gift-cards'
import { Route as GiftCardSuccessRouteImport } from './../../pages/gift-card-success'
import { Route as EventsRouteImport } from './../../pages/events'
import { Route as CheckoutRouteImport } from './../../pages/checkout'
import { Route as CartRouteImport } from './../../pages/cart'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as TeaDiaryAddRouteImport } from './../../pages/tea-diary.add'
import { Route as ProductProductIdRouteImport } from './../../pages/product.$productId'
import { Route as OrderOrderIdRouteImport } from './../../pages/order.$orderId'
import { Route as EventEventIdRouteImport } from './../../pages/event.$eventId'
import { Route as CatalogSectionRouteImport } from './../../pages/catalog.$section'
import { Route as TeaDiaryEditEntryIdRouteImport } from './../../pages/tea-diary.edit.$entryId'

const WantToDrinkRoute = WantToDrinkRouteImport.update({
  id: '/want-to-drink',
  path: '/want-to-drink',
  getParentRoute: () => rootRouteImport,
} as any)
const TeaDiaryRoute = TeaDiaryRouteImport.update({
  id: '/tea-diary',
  path: '/tea-diary',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentResultRoute = PaymentResultRouteImport.update({
  id: '/payment-result',
  path: '/payment-result',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderSuccessRoute = OrderSuccessRouteImport.update({
  id: '/order-success',
  path: '/order-success',
  getParentRoute: () => rootRouteImport,
} as any)
const OfferRoute = OfferRouteImport.update({
  id: '/offer',
  path: '/offer',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const MyGiftCardsRoute = MyGiftCardsRouteImport.update({
  id: '/my-gift-cards',
  path: '/my-gift-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftCardsRoute = GiftCardsRouteImport.update({
  id: '/gift-cards',
  path: '/gift-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftCardSuccessRoute = GiftCardSuccessRouteImport.update({
  id: '/gift-card-success',
  path: '/gift-card-success',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeaDiaryAddRoute = TeaDiaryAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => TeaDiaryRoute,
} as any)
const ProductProductIdRoute = ProductProductIdRouteImport.update({
  id: '/product/$productId',
  path: '/product/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderOrderIdRoute = OrderOrderIdRouteImport.update({
  id: '/order/$orderId',
  path: '/order/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const EventEventIdRoute = EventEventIdRouteImport.update({
  id: '/event/$eventId',
  path: '/event/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogSectionRoute = CatalogSectionRouteImport.update({
  id: '/catalog/$section',
  path: '/catalog/$section',
  getParentRoute: () => rootRouteImport,
} as any)
const TeaDiaryEditEntryIdRoute = TeaDiaryEditEntryIdRouteImport.update({
  id: '/edit/$entryId',
  path: '/edit/$entryId',
  getParentRoute: () => TeaDiaryRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/events': typeof EventsRoute
  '/gift-card-success': typeof GiftCardSuccessRoute
  '/gift-cards': typeof GiftCardsRoute
  '/my-gift-cards': typeof MyGiftCardsRoute
  '/not-found': typeof NotFoundRoute
  '/offer': typeof OfferRoute
  '/order-success': typeof OrderSuccessRoute
  '/orders': typeof OrdersRoute
  '/payment-result': typeof PaymentResultRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/reviews': typeof ReviewsRoute
  '/tea-diary': typeof TeaDiaryRouteWithChildren
  '/want-to-drink': typeof WantToDrinkRoute
  '/catalog/$section': typeof CatalogSectionRoute
  '/event/$eventId': typeof EventEventIdRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/tea-diary/add': typeof TeaDiaryAddRoute
  '/tea-diary/edit/$entryId': typeof TeaDiaryEditEntryIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/events': typeof EventsRoute
  '/gift-card-success': typeof GiftCardSuccessRoute
  '/gift-cards': typeof GiftCardsRoute
  '/my-gift-cards': typeof MyGiftCardsRoute
  '/not-found': typeof NotFoundRoute
  '/offer': typeof OfferRoute
  '/order-success': typeof OrderSuccessRoute
  '/orders': typeof OrdersRoute
  '/payment-result': typeof PaymentResultRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/reviews': typeof ReviewsRoute
  '/tea-diary': typeof TeaDiaryRouteWithChildren
  '/want-to-drink': typeof WantToDrinkRoute
  '/catalog/$section': typeof CatalogSectionRoute
  '/event/$eventId': typeof EventEventIdRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/tea-diary/add': typeof TeaDiaryAddRoute
  '/tea-diary/edit/$entryId': typeof TeaDiaryEditEntryIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/events': typeof EventsRoute
  '/gift-card-success': typeof GiftCardSuccessRoute
  '/gift-cards': typeof GiftCardsRoute
  '/my-gift-cards': typeof MyGiftCardsRoute
  '/not-found': typeof NotFoundRoute
  '/offer': typeof OfferRoute
  '/order-success': typeof OrderSuccessRoute
  '/orders': typeof OrdersRoute
  '/payment-result': typeof PaymentResultRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/reviews': typeof ReviewsRoute
  '/tea-diary': typeof TeaDiaryRouteWithChildren
  '/want-to-drink': typeof WantToDrinkRoute
  '/catalog/$section': typeof CatalogSectionRoute
  '/event/$eventId': typeof EventEventIdRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/product/$productId': typeof ProductProductIdRoute
  '/tea-diary/add': typeof TeaDiaryAddRoute
  '/tea-diary/edit/$entryId': typeof TeaDiaryEditEntryIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cart'
    | '/checkout'
    | '/events'
    | '/gift-card-success'
    | '/gift-cards'
    | '/my-gift-cards'
    | '/not-found'
    | '/offer'
    | '/order-success'
    | '/orders'
    | '/payment-result'
    | '/privacy'
    | '/profile'
    | '/reviews'
    | '/tea-diary'
    | '/want-to-drink'
    | '/catalog/$section'
    | '/event/$eventId'
    | '/order/$orderId'
    | '/product/$productId'
    | '/tea-diary/add'
    | '/tea-diary/edit/$entryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cart'
    | '/checkout'
    | '/events'
    | '/gift-card-success'
    | '/gift-cards'
    | '/my-gift-cards'
    | '/not-found'
    | '/offer'
    | '/order-success'
    | '/orders'
    | '/payment-result'
    | '/privacy'
    | '/profile'
    | '/reviews'
    | '/tea-diary'
    | '/want-to-drink'
    | '/catalog/$section'
    | '/event/$eventId'
    | '/order/$orderId'
    | '/product/$productId'
    | '/tea-diary/add'
    | '/tea-diary/edit/$entryId'
  id:
    | '__root__'
    | '/'
    | '/cart'
    | '/checkout'
    | '/events'
    | '/gift-card-success'
    | '/gift-cards'
    | '/my-gift-cards'
    | '/not-found'
    | '/offer'
    | '/order-success'
    | '/orders'
    | '/payment-result'
    | '/privacy'
    | '/profile'
    | '/reviews'
    | '/tea-diary'
    | '/want-to-drink'
    | '/catalog/$section'
    | '/event/$eventId'
    | '/order/$orderId'
    | '/product/$productId'
    | '/tea-diary/add'
    | '/tea-diary/edit/$entryId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  EventsRoute: typeof EventsRoute
  GiftCardSuccessRoute: typeof GiftCardSuccessRoute
  GiftCardsRoute: typeof GiftCardsRoute
  MyGiftCardsRoute: typeof MyGiftCardsRoute
  NotFoundRoute: typeof NotFoundRoute
  OfferRoute: typeof OfferRoute
  OrderSuccessRoute: typeof OrderSuccessRoute
  OrdersRoute: typeof OrdersRoute
  PaymentResultRoute: typeof PaymentResultRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  ReviewsRoute: typeof ReviewsRoute
  TeaDiaryRoute: typeof TeaDiaryRouteWithChildren
  WantToDrinkRoute: typeof WantToDrinkRoute
  CatalogSectionRoute: typeof CatalogSectionRoute
  EventEventIdRoute: typeof EventEventIdRoute
  OrderOrderIdRoute: typeof OrderOrderIdRoute
  ProductProductIdRoute: typeof ProductProductIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/want-to-drink': {
      id: '/want-to-drink'
      path: '/want-to-drink'
      fullPath: '/want-to-drink'
      preLoaderRoute: typeof WantToDrinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tea-diary': {
      id: '/tea-diary'
      path: '/tea-diary'
      fullPath: '/tea-diary'
      preLoaderRoute: typeof TeaDiaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-result': {
      id: '/payment-result'
      path: '/payment-result'
      fullPath: '/payment-result'
      preLoaderRoute: typeof PaymentResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-success': {
      id: '/order-success'
      path: '/order-success'
      fullPath: '/order-success'
      preLoaderRoute: typeof OrderSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offer': {
      id: '/offer'
      path: '/offer'
      fullPath: '/offer'
      preLoaderRoute: typeof OfferRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-gift-cards': {
      id: '/my-gift-cards'
      path: '/my-gift-cards'
      fullPath: '/my-gift-cards'
      preLoaderRoute: typeof MyGiftCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-cards': {
      id: '/gift-cards'
      path: '/gift-cards'
      fullPath: '/gift-cards'
      preLoaderRoute: typeof GiftCardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift-card-success': {
      id: '/gift-card-success'
      path: '/gift-card-success'
      fullPath: '/gift-card-success'
      preLoaderRoute: typeof GiftCardSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tea-diary/add': {
      id: '/tea-diary/add'
      path: '/add'
      fullPath: '/tea-diary/add'
      preLoaderRoute: typeof TeaDiaryAddRouteImport
      parentRoute: typeof TeaDiaryRoute
    }
    '/product/$productId': {
      id: '/product/$productId'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof ProductProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/$orderId': {
      id: '/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof OrderOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/event/$eventId': {
      id: '/event/$eventId'
      path: '/event/$eventId'
      fullPath: '/event/$eventId'
      preLoaderRoute: typeof EventEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/$section': {
      id: '/catalog/$section'
      path: '/catalog/$section'
      fullPath: '/catalog/$section'
      preLoaderRoute: typeof CatalogSectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tea-diary/edit/$entryId': {
      id: '/tea-diary/edit/$entryId'
      path: '/edit/$entryId'
      fullPath: '/tea-diary/edit/$entryId'
      preLoaderRoute: typeof TeaDiaryEditEntryIdRouteImport
      parentRoute: typeof TeaDiaryRoute
    }
  }
}

interface TeaDiaryRouteChildren {
  TeaDiaryAddRoute: typeof TeaDiaryAddRoute
  TeaDiaryEditEntryIdRoute: typeof TeaDiaryEditEntryIdRoute
}

const TeaDiaryRouteChildren: TeaDiaryRouteChildren = {
  TeaDiaryAddRoute: TeaDiaryAddRoute,
  TeaDiaryEditEntryIdRoute: TeaDiaryEditEntryIdRoute,
}

const TeaDiaryRouteWithChildren = TeaDiaryRoute._addFileChildren(
  TeaDiaryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  EventsRoute: EventsRoute,
  GiftCardSuccessRoute: GiftCardSuccessRoute,
  GiftCardsRoute: GiftCardsRoute,
  MyGiftCardsRoute: MyGiftCardsRoute,
  NotFoundRoute: NotFoundRoute,
  OfferRoute: OfferRoute,
  OrderSuccessRoute: OrderSuccessRoute,
  OrdersRoute: OrdersRoute,
  PaymentResultRoute: PaymentResultRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  ReviewsRoute: ReviewsRoute,
  TeaDiaryRoute: TeaDiaryRouteWithChildren,
  WantToDrinkRoute: WantToDrinkRoute,
  CatalogSectionRoute: CatalogSectionRoute,
  EventEventIdRoute: EventEventIdRoute,
  OrderOrderIdRoute: OrderOrderIdRoute,
  ProductProductIdRoute: ProductProductIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
